<template>
  <div>
    <h2 class="text-2xl font-semibold">Comments</h2>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="comments.result"
      border
    >
      <!-- .slice((currentPage - 1) * perPage, currentPage * perPage) -->
      <el-table-column label="Comment" min-width="150px" prop="title">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.comment }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Replies" min-width="150px" prop="replies">
        <template v-slot="{ row }">
          <span
            class="cursor-pointer text-black font-medium"
            @click="showReplies(row)"
            >({{ row.totalReplies }})
            <span class="underline"> View </span></span
          >
        </template>
      </el-table-column>
      <el-table-column label="Likes" min-width="150px" prop="totalLikes">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.totalLikes }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Reported" min-width="130px" prop="reported">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.isReported ? "Yes" : "No"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Created by" min-width="150px" prop="createdBy">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row._user ? row._user.firstname + " " + row._user.lastname : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Date" min-width="130px" prop="date">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            new Date(row.createdAt).toLocaleDateString(undefined, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template v-slot="{ row }">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(row)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>
<script>
import { mapState } from "vuex";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      userToggle: false,
      currentPage: 1,
      total_row: 1,
      perPage: 5,
    };
  },
  methods: {
    handleDelete(comment) {
      let loader = this.$loading();
      this.$swal({
        title: `Are you sure`,
        text: "Do you want to delete?",
        showCancelButton: true,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "YES",
        cancelButtonText: "No",
        icon: "warning",
      }).then(async (result) => {
        loader.close();
        if (result.value) {
          await this.$store.dispatch("posts/adminDeleteComment", comment);
          this.dataLoad();
          this.$swal(
            "Deleted!",
            "Post has been successfully deleted",
            "success",
            "#4f0a4b"
          );
          loader.close();
        }
      });
    },

    async dataLoad() {
      let loader = this.$loading();
      try {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
          postID: this.$route.query.post,
        };
        await this.$store.dispatch("posts/getAllComments", payload);
        this.total_row = this.comments.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },

    async handlePageChange(value) {
      this.currentPage = value;
      try {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
        await this.$store.dispatch("posts/getAllComments", payload);
        this.total_row = this.comments.totalCount;
      } catch (error) {}
    },
    showReplies(val) {
      try {
        this.$router.push({ name: "replies", query: { comment: val._id } });
      } catch (error) {
        console.log(error);
      }
    },
  },

  computed: {
    ...mapState("channel", ["selectedChannel"]),
    ...mapState("admin", ["post"]),
    ...mapState("posts", ["comments"]),
  },
  mounted: function () {
    this.dataLoad();
  },
};
</script>
<style>
.swal2-confirm {
  background-color: #4f0a4b !important;
}
</style>
